import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getTrainings = async () => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/training`, {
        headers: { Authorization: token }
    });
};

export const getTraining = async (id) => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/training/view/${id}`, {
        headers: { Authorization: token }
    });
};

export const addTraining = async (formBack) => {
    const token = await cookie.get("token");
    return await axios.post(`${proxy}/training/create`, formBack, {
        headers: { Authorization: token }
    });
};

export const updateTraining = async (id, video, name, description) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/training/update/${id}`, {
        video: video,
        name: name,
        description: description,
    }, {
        headers: { Authorization: token }
    });
};

export const deleteTraining = async (id) => {
    const token = await cookie.get("token");
    return await axios.delete(`${proxy}/training/${id}`, {
        headers: { Authorization: token }
    });
};